'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.parseMultipartHttp = parseMultipartHttp;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function getDelimiter(boundary) {
    return '\r\n--' + boundary + '\r\n';
}

function getFinalDelimiter(boundary) {
    return '\r\n--' + boundary + '--\r\n';
}

function splitWithRest(string, delim) {
    var index = string.indexOf(delim);
    if (index < 0) {
        return [string];
    }
    return [string.substring(0, index), string.substring(index + delim.length)];
}

function parseMultipartHttp(buffer, boundary) {
    var previousParts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var delimeter = getDelimiter(boundary);

    var _splitWithRest = splitWithRest(buffer, delimeter),
        _splitWithRest2 = _slicedToArray(_splitWithRest, 2),
        rest = _splitWithRest2[1];

    if (!(rest && rest.length)) {
        // we did not finish receiving the initial delimeter
        return {
            newBuffer: buffer,
            parts: previousParts
        };
    }
    var parts = splitWithRest(rest, '\r\n\r\n');
    var headers = parts[0];
    rest = parts[1];

    if (!(rest && rest.length)) {
        // we did not finish receiving the headers
        return {
            newBuffer: buffer,
            parts: previousParts
        };
    }

    var headersArr = headers.split('\r\n');
    var contentLengthHeader = headersArr.find(function (headerLine) {
        return headerLine.toLowerCase().indexOf('content-length:') >= 0;
    });
    if (contentLengthHeader === undefined) {
        throw new Error('Invalid MultiPart Response, no content-length header');
    }
    var contentLengthArr = contentLengthHeader.split(':');
    var contentLength = void 0;
    if (contentLengthArr.length === 2 && !isNaN(parseInt(contentLengthArr[1]))) {
        contentLength = parseInt(contentLengthArr[1]);
    } else {
        throw new Error('Invalid MultiPart Response, could not parse content-length');
    }

    // Strip out the final delimiter
    var finalDelimeter = getFinalDelimiter(boundary);
    rest = rest.replace(finalDelimeter, '');
    var uint = new TextEncoder().encode(rest);

    if (uint.length < contentLength) {
        // still waiting for more body to be sent;
        return {
            newBuffer: buffer,
            parts: previousParts
        };
    }

    var body = new TextDecoder().decode(uint.subarray(0, contentLength));
    var nextBuffer = new TextDecoder().decode(uint.subarray(contentLength));
    var part = JSON.parse(body);
    var newParts = [].concat(_toConsumableArray(previousParts), [part]);

    if (nextBuffer.length) {
        return parseMultipartHttp(nextBuffer, boundary, newParts);
    }
    return { parts: newParts, newBuffer: '' };
}